import React from 'react'
import { useValueEditor, ValueEditor } from 'react-querybuilder'
import { format } from 'date-fns'
import {
    yesNoOptions,
    yesNoOptions01,
} from '../../../../select/StaticSelectObjects'
import {
    InputFieldColumn,
    InputFieldColumnSimple,
    RequiredError,
} from '../InputField'
import BaseDatePicker from '../../../../date-picker/ReportDatePicket'
import { BaseSelect } from '../../../../select/ReportSelect'

export const CustomValueEditor = props => {
    const dateFormat = 'MM/dd/yyyy'
    const disabled = props.context?.viewOnly ?? false
    const {
        className,
        handleOnChange,
        fieldData: { maxLength, inputType, type },
        rule,
        operator,
        validation,
    } = props

    const { valueAsArray, multiValueHandler } = useValueEditor(props)

    const noValueOperators = ['null', 'notNull']
    if (noValueOperators.includes(operator)) {
        return null
    }

    const valueEditorClass = `${className} input is-normal`
    let editorArray = ['from']
    let onChangeFunction = handleOnChange
    if (operator === 'between' || operator === 'notBetween') {
        editorArray = ['from', 'to']
        onChangeFunction = multiValueHandler
    }

    // Define common props as an object
    const commonFieldProps = {
        className: valueEditorClass,
        handleOnChange: onChangeFunction,
    }

    const editors = editorArray.map((key, i) => {
        let ruleValue = rule.value
        if (operator === 'between' || operator === 'notBetween') {
            ruleValue = valueAsArray[i] // value as array values don't allow spaces
        }
        // let ruleValue = valueAsArray[i] ?? rule.value
        const ruleTitle = ruleValue
        let validatorResult = {
            valid: true,
            reasons: {},
        }
        if (validation && !validation.valid) {
            validatorResult = { field: { message: validation.reasons[i] } }
        }

        const onClear = () => {
            onChangeFunction('', i)
        }

        const isInOperator = operator === 'in' || operator === 'notIn'
        const isNumericType = inputType === 'number' || ['int', 'decimal', 'double', 'real', 'float'].includes(type)
        
        if (isInOperator && isNumericType) {
            return (
                <InputFieldColumnSimple
                    name={`field`}
                    key={`${key}.${i}`}
                    style={{ width: '100%' }}
                    fieldErrors={validatorResult}
                    onClear={onClear}
                    inputProps={{
                        type: 'text',
                        value: ruleValue,
                        maxLength,
                        onChange: e =>
                            commonFieldProps.handleOnChange(e.currentTarget.value, i),
                        ...commonFieldProps,
                    }}
                />
            )
        }

        switch (inputType) {
            case 'text':
                return (
                    <InputFieldColumnSimple
                        name={`field`}
                        key={`${key}.${i}`}
                        style={{ width: '100%' }}
                        fieldErrors={validatorResult}
                        onClear={onClear}
                        inputProps={{
                            type: 'text',
                            value: ruleValue,
                            maxLength,
                            onChange: e =>
                                commonFieldProps.handleOnChange(e.currentTarget.value, i),
                            ...commonFieldProps,
                        }}
                    />
                )
            case 'number':
                if (type === 'int') {
                    return (
                        <InputFieldColumnSimple
                            name={`field`}
                            key={`${key}.${i}`}
                            style={{ width: '100%' }}
                            fieldErrors={validatorResult}
                            onClear={onClear}
                            inputProps={{
                                type: 'number',
                                decimalScale: 0,
                                onChange: e =>
                                    commonFieldProps.handleOnChange(e.currentTarget.value, i),
                                value: ruleValue,
                                title: ruleTitle,
                                ...commonFieldProps,
                            }}
                        />
                    )
                } else if (
                    type === 'decimal' ||
                    type === 'double' ||
                    type === 'real'
                ) {
                    return (
                        <InputFieldColumnSimple
                            name={`field`}
                            key={`${key}.${i}`}
                            style={{ width: '100%' }}
                            fieldErrors={validatorResult}
                            onClear={onClear}
                            inputProps={{
                                type: 'number',
                                step: '0.1',
                                maxLength,
                                onChange: e =>
                                    commonFieldProps.handleOnChange(e.currentTarget.value, i),
                                value: ruleValue,
                                title: ruleTitle,
                                ...commonFieldProps,
                            }}
                        />
                    )
                } else {
                    return (
                        <InputFieldColumnSimple
                            name={`field`}
                            key={`${key}.${i}`}
                            style={{ width: '100%' }}
                            fieldErrors={validatorResult}
                            onClear={onClear}
                            inputProps={{
                                type: 'number',
                                onChange: e =>
                                    commonFieldProps.handleOnChange(e.currentTarget.value, i),
                                value: ruleValue,
                                title: ruleTitle,
                                ...commonFieldProps,
                            }}
                        />
                    )
                }
            case 'date':
                return (
                    <div style={{ width: '100%' }} title={ruleTitle}>
                        <InputFieldColumn
                            name={`field`}
                            fieldErrors={validatorResult}
                            isClearable={false}
                        >
                            <BaseDatePicker
                                key={`${key}.${i}`}
                                wrapperStyle={{ width: '100%', padding: 0 }}
                                currentValue={ruleValue}
                                handleOnChange={d => {
                                    commonFieldProps.handleOnChange(d ? format(d, dateFormat) : null, i)
                                }}
                            />
                        </InputFieldColumn>
                    </div>
                )
            case 'boolean':
                return (
                    <div style={{ width: '100%' }} title={ruleTitle}>
                        <InputFieldColumn
                            name={`field`} // no errors for this input type
                            fieldErrors={validatorResult}
                            isClearable={false}
                        >
                            <BaseSelect
                                key={`${key}.${i}`}
                                {...commonFieldProps}
                                defaultValue={yesNoOptions01.find(
                                    v => v.value === ruleValue
                                )}
                                value={yesNoOptions01.find(
                                    v => v.value === ruleValue
                                )}
                                onChange={option => {
                                    commonFieldProps.handleOnChange(option?.value || '', i)
                                    return option
                                }}
                                className={className}
                                disabled={disabled}
                                options={yesNoOptions01}
                                isClearable={true}
                                placeholder="Select..."
                            />
                        </InputFieldColumn>
                    </div>
                )
            default:
                return (
                    <InputFieldColumnSimple
                        name={`field`}
                        key={`${key}.${i}`}
                        style={{ width: '100%' }}
                        fieldErrors={validatorResult}
                        onClear={onClear}
                        inputProps={{
                            type: 'text',
                            value: ruleValue,
                            maxLength,
                            onChange: e =>
                                commonFieldProps.handleOnChange(e.currentTarget.value, i),
                            ...commonFieldProps,
                        }}
                    />
                )
        }
    })

    return (
        <>
            {/* // <span data-testid={testID} className={className}> */}
            {editors[0]}
            {/* {separator} */}
            {operator === 'between' || operator === 'notBetween'
                ? editors[1]
                : null}
            {/* // </span> */}
        </>
    )
}
